const departamentos = [
  {
    titulo: 'Facturación',
    icono: '🧾',
    telefono: '52 (431) 688-0121',
    email: 'facturacion@acerosjalos.com.mx',
    direccion: 'Carretera San Juan de los Lagos #191, C.P. 47120, Jalostotitlán, Jalisco',
  },
  {
    titulo: 'Crédito y Cobranza',
    icono: '💳',
    telefono: '52 (431) 688-0121',
    email: 'creditoycobranza@acerosjalos.com.mx',
    direccion: 'Carretera a San Juan de los Lagos #191, C.P. 47120, Jalostotitlán, Jalisco',
  },
];

export default function Facturacion() {
  return (
    <section className="facturacion">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Información administrativa</p>
          <h2 className="section-title dark">Facturación y Crédito</h2>
          <div className="section-divider" />
        </div>

        <div className="fact-grid">
          {departamentos.map(({ titulo, icono, telefono, email, direccion }) => (
            <div key={titulo} className="fact-card">
              <div className="fact-icon">{icono}</div>
              <h3 className="fact-title">{titulo}</h3>

              <div className="fact-item">
                <span className="fact-label">Teléfono</span>
                <span className="fact-value">{telefono}</span>
              </div>
              <div className="fact-item">
                <span className="fact-label">Correo</span>
                <a href={`mailto:${email}`} className="fact-value fact-link">{email}</a>
              </div>
              <div className="fact-item">
                <span className="fact-label">Dirección</span>
                <span className="fact-value">{direccion}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
